<script lang="ts">
	import type { BoxColoredProps } from './types';
	import { attrValue } from '$lib/utils/html';
	import { smoothScroll } from '$lib/actions';
	import { goto } from '$app/navigation';

	export let props: BoxColoredProps;

	let getColorClasses: () => string;
	$: getColorClasses = () => {
		if (!props?.color) return 'bg-white text-text';

		switch (props.color) {
			case 'secondary':
				return 'bg-secondary text-white';
			case 'premium':
				return 'bg-premium text-white';
			case 'primary':
				return 'bg-primary text-white';
			case 'danger':
				return 'bg-danger text-white';
			case 'grey-light':
				return 'bg-grey-light text-secondary';
			case 'success':
				return 'bg-success text-white';
			case 'grey-lighter':
				return 'bg-grey-lighter text-secondary';
			case 'transparent':
				return 'bg-transparent text-secondary';
			case 'real-estate':
				return 'bg-real-estate text-white';
			default:
				return 'bg-white text-text';
		}
	};
</script>

<div
	class={attrValue([
		getColorClasses(),
		props?.classNames,
		`${props?.smoothScroll || props?.link ? 'cursor-pointer' : ''} ${!props?.hasNoPadding ? 'p-3 md:p-4' : ''} ${!props?.hasNoBorder ? 'border border-grey-light' : ''} ${!props?.hasNoShadow ? ' shadow' : ''} ${props?.isFullHeight ? 'h-full' : ''} rounded-lg`
	])}
	on:mouseenter
	on:mouseleave
	on:click
	on:click={() => {
		props?.link && goto(props?.link);
	}}
	use:smoothScroll={props?.smoothScroll}
	bind:this={props.ref}
>
	<slot />
</div>
